import { Entity, Field } from "typegraph";

import { ID } from "common/entities/IEntity";
import IdName from "core/util/IdName";
import { filterParams } from "core/util/ParamUtil";

export interface IOrganizationParams {
	guid: string;
}

@Entity({
	one: "organization"
})
export class Organization {

	@Field()
	public id: ID;

	@Field()
	public name: string;

	@Field({entity: IdName})
	public group: IdName;

}



// WEBPACK FOOTER //
// ./src/panels/organizationAdmin/entities/Organization.ts